import { DataGrid as MuiDataGrid, DataGridProps } from '@mui/x-data-grid';
import { FC } from 'react';
import { YodaColors } from 'yoda-ui/yodaTheme';

const DataGrid: FC<DataGridProps> = (props) => (
  <MuiDataGrid
    { ...props }
    sx={
      {
        ...props.sx as object,
        '& .MuiDataGrid-overlayWrapper': { height: '100%' },
        '& .MuiDataGrid-overlay': {
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 10,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          color: YodaColors.blue7,
        },
        '& .MuiDataGrid-row.MuiDataGrid-row': {
          boxShadow: `inset 0 0 0 1px ${YodaColors.gray2}, 0px 2px 4px rgba(87, 102, 126, 0.08)`,
          transition: 'box-shadow .2s ease-out, background-color .2s ease-out',
        },
        '& .MuiDataGrid-row.MuiDataGrid-row:hover, & .MuiDataGrid-row.MuiDataGrid-row:focus': {
          boxShadow: `inset 0 0 0 1px ${YodaColors.gray2}, 0 2px 10px 0 rgba(18, 32, 53, 0.1)`,
        },
      }
    }
  />
);

export default DataGrid;
